import { useEffect, useState } from 'react'
import qs from 'qs'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import DashboardFilters, {
  PerResidentFilters,
} from './components/DashboardFilters/DashboardFilters'
import DashboardBody from './components/DashboardBody/DashboardBody'
import { useParams } from 'react-router-dom'
import { PerResidentResponse } from '@lmc/ts-common'
import styled from 'styled-components'

const generateApiUrl = (filterParams: PerResidentFilters) => {
  const { resident, rangePicker } = filterParams

  const queryStr = qs.stringify({
    resident,
    from: rangePicker?.[0]?.toISOString(),
    to: rangePicker?.[1]?.toISOString(),
    riskAssessment: filterParams.riskAssessment,
  })

  return `/api/list/risk-assessments/dashboard/per-resident?${queryStr}`
}

const PerResidentScreen = () => {
  const { id } = useParams()
  const initialFiltersValue: PerResidentFilters = {
    rangePicker: [
      dayjs().subtract(12, 'month').startOf('day'),
      dayjs().endOf('day'),
    ],
    resident: id,
    riskAssessment: null,
  }
  const [filterParams, setFilterParams] =
    useState<PerResidentFilters>(initialFiltersValue)
  const url = generateApiUrl(filterParams)

  const { isLoading, data } = useQuery<PerResidentResponse>(url, () =>
    getJSON({ url })
  )

  useEffect(() => {
    setFilterParams({
      ...filterParams,
      resident: id,
    })
  }, [id])

  return (
    <Container>
      <DashboardFilters onChange={setFilterParams} value={filterParams} />
      <DashboardBody
        data={data}
        filterParams={filterParams}
        isLoading={isLoading}
      />
    </Container>
  )
}

const Container = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  width: 100%;
`

export default PerResidentScreen
